<template>
<p>Under Construction ...</p>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
    name: "MyOpponents",
    })
</script>